import { render } from "./NBbox.vue?vue&type=template&id=6c4b1328&ts=true"
import script from "./NBbox.vue?vue&type=script&lang=ts"
export * from "./NBbox.vue?vue&type=script&lang=ts"

import "./NBbox.vue?vue&type=style&index=0&id=6c4b1328&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__